// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bold-600{
    font-weight: 600;
    font-family: 'Montserrat';
}
.font-24{
    font-size: 24px;
}
.font-22{
    font-size: 22px;
}
.front{
    margin-top: 80px;
    margin-bottom: 160px;
     /* background-color: #1b57d9; */
     background-image: url(/assets/images/front/Rectangle.svg);
}
.rate{
    position: absolute;
    width: 100%;
    top: 105px;
}
label{
    color: black;
    font-weight: 500;
}
.card .form-control{
    border: 1px solid #c3c3c3;
    height: 70px;
}
.shadow {
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.10)!important;
}
.copy{
    position: absolute;
    border-radius: 60px;
    padding: 20px 60px;
    background: #0070C0;
    text-align: center;
    color: white;
    width: 100%;
    height: 90px;
}
.block{
    background: #D9D9D9;

}
h6{
    margin: 0;
    font-weight: 500;
    color: #000;
}
.border-right-1{
    border-right: 2px solid #707070;
}
.btn-sign{
    background: #10C7FC;
    padding: 16px 32px;
    height: 70px;
    width: 75%;
    color: white;
    font-size: 24px;
    font-family: 'Roboto';
    font-weight: 500;
}
.btn-login{
    background: white;
    font-size: 24px;
    font-family: 'Roboto';
    font-weight: 500;
    padding: 16px 32px;
    height: 70px;
    width: 75%;
    border: 1px solid #707070;
    color: black;
}
.btns p{
    width: 60%;
    font-size: 16px;
    /* text-align: center; */
}
.form-control{
    height: 52px;
}
.w-25{
    height: 50px;
    padding: 6px 22px;
    width: 18% !important;
}
.resend{
    border: none;
    background: white;
    font-weight: 500;
    opacity: .8;
}
.eye{
    position: absolute;
     /* top: 113px; */
     top: 15px;
    right: 20px;
 }
 .box{
    margin: 0 300px;
    border: 1px dashed #0270c0;
    padding: 16px;
 }
@media screen and (max-width:600px) {
    .front{
        margin-top: 30px;
        display: none;
    }
    .rate{
        position: relative;
        top: 70px;
        margin-bottom: 150px;
    } 
    .copy{
        border-radius: 30px;
        padding: 12px 24px;
    }
    .border-right-1{
        border-bottom: 2px solid #707070;
    }
    .btn-login,.btn-sign,.btn p{
        width: 100%;
    }
    .mob-promo{
        background: #1b57d9;
    }
    .font-24,.bold-600{
        font-size: 20px; 
    }
    .form-control{
        height: 44px;
    }
    .w-25{
        height: 46px;
        width: 100% !important;
        padding: 4px 22px;
    }
    .eye{
        top: 12px;
        right: 18px;
     }
     .border-right-1{
         border-right: 0px;
     }
     .btns p{
        width: 100%;
    }
     .txt{
         text-align: center !important;
     }
    .box{
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/studentDashboard/front/front.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,oBAAoB;KACnB,+BAA+B;KAC/B,yDAAyD;AAC9D;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kDAAkD;AACtD;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;AACA;IACI,mBAAmB;;AAEvB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,+BAA+B;AACnC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,UAAU;IACV,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;KACjB,gBAAgB;KAChB,SAAS;IACV,WAAW;CACd;CACA;IACG,eAAe;IACf,0BAA0B;IAC1B,aAAa;CAChB;AACD;IACI;QACI,gBAAgB;QAChB,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,gCAAgC;IACpC;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,sBAAsB;QACtB,iBAAiB;IACrB;IACA;QACI,SAAS;QACT,WAAW;KACd;KACA;SACI,iBAAiB;KACrB;KACA;QACG,WAAW;IACf;KACC;SACI,6BAA6B;KACjC;IACD;QACI,SAAS;IACb;AACJ","sourcesContent":[".bold-600{\n    font-weight: 600;\n    font-family: 'Montserrat';\n}\n.font-24{\n    font-size: 24px;\n}\n.font-22{\n    font-size: 22px;\n}\n.front{\n    margin-top: 80px;\n    margin-bottom: 160px;\n     /* background-color: #1b57d9; */\n     background-image: url(/assets/images/front/Rectangle.svg);\n}\n.rate{\n    position: absolute;\n    width: 100%;\n    top: 105px;\n}\nlabel{\n    color: black;\n    font-weight: 500;\n}\n.card .form-control{\n    border: 1px solid #c3c3c3;\n    height: 70px;\n}\n.shadow {\n    box-shadow: 0 .5rem 1rem rgba(0,0,0,.10)!important;\n}\n.copy{\n    position: absolute;\n    border-radius: 60px;\n    padding: 20px 60px;\n    background: #0070C0;\n    text-align: center;\n    color: white;\n    width: 100%;\n    height: 90px;\n}\n.block{\n    background: #D9D9D9;\n\n}\nh6{\n    margin: 0;\n    font-weight: 500;\n    color: #000;\n}\n.border-right-1{\n    border-right: 2px solid #707070;\n}\n.btn-sign{\n    background: #10C7FC;\n    padding: 16px 32px;\n    height: 70px;\n    width: 75%;\n    color: white;\n    font-size: 24px;\n    font-family: 'Roboto';\n    font-weight: 500;\n}\n.btn-login{\n    background: white;\n    font-size: 24px;\n    font-family: 'Roboto';\n    font-weight: 500;\n    padding: 16px 32px;\n    height: 70px;\n    width: 75%;\n    border: 1px solid #707070;\n    color: black;\n}\n.btns p{\n    width: 60%;\n    font-size: 16px;\n    /* text-align: center; */\n}\n.form-control{\n    height: 52px;\n}\n.w-25{\n    height: 50px;\n    padding: 6px 22px;\n    width: 18% !important;\n}\n.resend{\n    border: none;\n    background: white;\n    font-weight: 500;\n    opacity: .8;\n}\n.eye{\n    position: absolute;\n     /* top: 113px; */\n     top: 15px;\n    right: 20px;\n }\n .box{\n    margin: 0 300px;\n    border: 1px dashed #0270c0;\n    padding: 16px;\n }\n@media screen and (max-width:600px) {\n    .front{\n        margin-top: 30px;\n        display: none;\n    }\n    .rate{\n        position: relative;\n        top: 70px;\n        margin-bottom: 150px;\n    } \n    .copy{\n        border-radius: 30px;\n        padding: 12px 24px;\n    }\n    .border-right-1{\n        border-bottom: 2px solid #707070;\n    }\n    .btn-login,.btn-sign,.btn p{\n        width: 100%;\n    }\n    .mob-promo{\n        background: #1b57d9;\n    }\n    .font-24,.bold-600{\n        font-size: 20px; \n    }\n    .form-control{\n        height: 44px;\n    }\n    .w-25{\n        height: 46px;\n        width: 100% !important;\n        padding: 4px 22px;\n    }\n    .eye{\n        top: 12px;\n        right: 18px;\n     }\n     .border-right-1{\n         border-right: 0px;\n     }\n     .btns p{\n        width: 100%;\n    }\n     .txt{\n         text-align: center !important;\n     }\n    .box{\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
